import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from '../../base/base.service';
import { Announcement } from './../../../models/announcements.model';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService extends BaseService<Announcement> {
  hasUnreadMessagesChanges = new BehaviorSubject<boolean>(false);
  constructor(protected http: HttpClient) {
    super(http, 'announcements');
  }

  retrieveAnnouncements(
    id: number | string | undefined
  ): Observable<HttpResponse<Announcement>> {
    return this.http.get<Announcement>(`${this.resourceUrl}/${id}`, {
      observe: 'response'
    });
  }
}
